import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-export',
  templateUrl: './export.component.html',
  styleUrls: ['./export.component.css']
})
export class ExportComponent implements OnInit {
  public exportForm: UntypedFormGroup;
  api_error: any;
  api_success: string;
  disableConfirmbtn = false;
  accountId: any;
  inventorycatelogDetails: any;
  constructor(private formbuilder: UntypedFormBuilder, private accountService: AccountService, private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {
      
      this.accountId = this.data.accountId;
      this.getinventorycatalog()
     }
  formErrors = {
    'email': ''
  };
  ValidationMessages = {
    'email': {
      'required': 'Email is required'
    },
  };
  export_list: any = [
    {
      "displayName": "SP Items",
      "value": "SPITEMS"
    },
    {
      "displayName": "Inventory Catelog Item",
      "value": "INVCATALOGITEM"
    }
   
  ]
  ngOnInit(): void {
    this.createForm();
  }
  createForm() {
    this.exportForm = this.formbuilder.group({
      email: ['', [Validators.required]],
      migrationType : [''],
      invcatelog : [''],
    });
  }
  getinventorycatalog(){
    this.accountService.getinventorycatalog(this.accountId)
    .subscribe(
      res => {
        this.inventorycatelogDetails = res;
      }
    );
  }
  logValidationErrors(group: UntypedFormGroup = this.exportForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }
      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });
  }
  export() {
    if (this.exportForm.get('email').value === '') {
      this.api_error = 'Email is required';
      setTimeout(() => {
        this.api_error = '';
      }, 2000);
    }
    else if (this.exportForm.get('migrationType').value === '') {
      this.api_error = 'Choose any Export Type';
      setTimeout(() => {
        this.api_error = '';
      }, 2000);
    }
    else if (this.exportForm.get('migrationType').value === 'INVCATALOGITEM' && this.exportForm.get('invcatelog').value === '') {
      this.api_error = 'Catelog ID is required';
      setTimeout(() => {
        this.api_error = '';
      }, 2000);
    } 
    else {
      if(this.exportForm.get('migrationType').value === 'INVCATALOGITEM'){
        const post_data = {
          email: this.exportForm.get('email').value,
          icEncId: this.exportForm.get('invcatelog').value
        };
        this.api_error = '';
        this.api_success = '';
        this.disableConfirmbtn = false;
        this.accountService.export_invItem(post_data, this.accountId).subscribe(
          res => {
            this.api_success = 'Data Export Successfully';
            setTimeout(() => {
              this.dialogRef.close('reloadlist');
            }, 2000);
          },
          error => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
          }
        );
      }else{
        const post_data = {
          email: this.exportForm.get('email').value,
        };
        this.api_error = '';
        this.api_success = '';
        this.disableConfirmbtn = false;
        this.accountService.export_SpItems(post_data, this.accountId).subscribe(
          res => {
            this.api_success = 'Data Export Successfully';
            setTimeout(() => {
              this.dialogRef.close('reloadlist');
            }, 2000);
          },
          error => {
            this.disableConfirmbtn = false;
            this.api_error = error.error;
          }
        );
      }
     
    }
  }
}
